import React from 'react'
import { formatNumbers } from '../Functions/formatNumbers'

export const Totals = (props) => {

	const [totalSum, setTotalSum] = React.useState(0)

	
	
	React.useEffect(() => { 
		setTotalSum(formatNumbers(roundTo(props.bestellung.totals.allTotalNetto * 1.19, 2)))
	}, [props.bestellung.totals.allTotalNetto])

	const roundTo = (n, digits) => {
        if (digits === undefined) {
            digits = 0;
        }

        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        return Math.round(n) / multiplicator;
	}
	

	// console.log((props.bestellung.totals.allTotalNetto * 1.19).toFixed(2))

	return (
		<div className="no__total-sum">
			<hr />
			<h3>{totalSum} €</h3>
		</div>
	)
}
